import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
//import './ChangePassword.css'; // Assuming your CSS is in this file
import backgroundImage from '../../Assets/backgroundImage1.png'; // Left side image (you can change this if needed)
import { API_BASE_URL } from '../../config';

export default function ChangePassword() {
  const [formData, setFormData] = useState({
    email: '',
    currentPassword: '',
    newPassword: '',
  });
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.currentPassword) newErrors.currentPassword = 'Current Password is required';
    if (!formData.newPassword) newErrors.newPassword = 'New Password is required';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/ChangePassword.php`, formData);
      if (response.data.status === 'success') {
        setMessage('Password updated successfully!');
        setTimeout(() => {
          navigate('/login'); // Redirect to login page after successful password change
        }, 2000);
      } else {
        setMessage(response.data.message);
      }
    } catch (error) {
      setMessage('There was an error submitting the form. Please try again.');
    }
  };

  return (
    <div className="container-split">
      <div className="image-half" style={{ backgroundImage: `url(${backgroundImage})` }}>
        {/* Optional: You can also add additional content over the image */}
      </div>
      <div className="form-half">
        <div className="access-container1">
          <h2 className="access-title">Change Password</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter Email"
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formCurrentPassword">
              <Form.Label>Current Password</Form.Label>
              <Form.Control
                type="password"
                name="currentPassword"
                value={formData.currentPassword}
                onChange={handleChange}
                placeholder="Enter Current Password"
                isInvalid={!!errors.currentPassword}
              />
              <Form.Control.Feedback type="invalid">{errors.currentPassword}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formNewPassword">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                name="newPassword"
                value={formData.newPassword}
                onChange={handleChange}
                placeholder="Enter New Password"
                isInvalid={!!errors.newPassword}
              />
              <Form.Control.Feedback type="invalid">{errors.newPassword}</Form.Control.Feedback>
            </Form.Group>

            <Button variant="primary" type="submit" className="button1">
              Change Password
            </Button>
          </Form>

          {message && <p className="mt-3 text-center">{message}</p>}

         
        </div>
      </div>
    </div>
  );
}

